import './index.scss'

$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //婊氬姩楂樺害
  $('.pro-detail-banner .bg').css('transform','translateY('+ scroH / 3 +'px)')
});
